
/**
 * Format a date string or Date object to a localized string format
 * @param date A date string or Date object
 * @returns Formatted date string in Italian locale
 */
export const formatDate = (date: string | Date): string => {
  if (!date) return "";
  
  try {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return dateObj.toLocaleDateString('it-IT', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  } catch (error) {
    console.error('[formatDate] Error formatting date:', error);
    return typeof date === 'string' ? date : date.toString();
  }
};

/**
 * Calculate reading time based on content length
 * @param content HTML or text content
 * @returns Formatted reading time string (e.g., "5 min")
 */
export const calculateReadingTime = (content: string): string => {
  if (!content) return "1 min";
  
  // Remove HTML tags and count words
  const text = content.replace(/<[^>]+>/g, '');
  const words = text.split(/\s+/).length;
  
  // Assume reading speed of 200 words per minute
  const minutes = Math.max(1, Math.ceil(words / 200));
  
  return `${minutes} min`;
};
